import { useState } from "react";

import { api, luuToken, LoiApi } from "../api.ts";
import { Bao, Nut, Truong, lopO } from "../thanh-phan/giao-dien.tsx";

export function DangNhap({ khiXong }: { khiXong: () => void }) {
  // ⚠️ AP-103: KHÔNG dùng `defaultValue` cho giá trị mà máy chủ cũng đổi được.
  // Hai ô dưới đây là state có kiểm soát ngay từ ký tự đầu tiên.
  const [email, datEmail] = useState("");
  const [matKhau, datMatKhau] = useState("");
  const [loi, datLoi] = useState<string | null>(null);
  const [dangChay, datDangChay] = useState(false);

  async function gui(e: React.FormEvent) {
    e.preventDefault();
    datLoi(null);
    datDangChay(true);
    try {
      const kq = await api.dangNhap(email.trim(), matKhau);
      luuToken(kq.token);
      khiXong();
    } catch (err) {
      datLoi(err instanceof LoiApi ? err.message : "Lỗi không rõ.");
    } finally {
      datDangChay(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muc-50 p-4">
      <form
        onSubmit={gui}
        className="w-full max-w-sm space-y-4 rounded-card border border-muc-300 bg-muc-0 p-6 shadow-card"
      >
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-muc-900">AutoIME</h1>
          <p className="mt-1 text-xs text-muc-500">
            Bảng điều khiển sản xuất nội dung cho Website IME.
          </p>
        </div>

        {/*
          `type="text"`, KHÔNG phải `type="email"`. Tên đăng nhập là `lynust` — một chuỗi trần.
          Để `type="email"` thì trình duyệt tự chặn ngay tại ô nhập, **trước khi có request nào**,
          và lỗi hiện ra là bong bóng của trình duyệt chứ không phải thông điệp của máy chủ —
          nhìn như dashboard hỏng chứ không như nhập sai.
        */}
        <Truong nhan="Tên đăng nhập">
          <input
            type="text"
            value={email}
            onChange={(e) => datEmail(e.target.value)}
            autoComplete="username"
            required
            className={lopO}
          />
        </Truong>

        <Truong nhan="Mật khẩu">
          <input
            type="password"
            value={matKhau}
            onChange={(e) => datMatKhau(e.target.value)}
            autoComplete="current-password"
            required
            className={lopO}
          />
        </Truong>

        {loi !== null && <Bao muc="loi">{loi}</Bao>}

        <Nut kieu="chinh" type="submit" dangChay={dangChay} className="w-full">
          Đăng nhập
        </Nut>

        <p className="text-2xs text-muc-500">
          Chưa có tài khoản? Tạo bằng lệnh trên máy chủ:
          <br />
          <code className="text-muc-600">pnpm --filter @autoime/api tao-tai-khoan</code>
        </p>
      </form>
    </div>
  );
}
